import { useCallback, useState } from 'react'
import KEYBOARD_SHORTCUTS from '../../constants/shortcuts'
import { useKeyboardShortcut } from '../../hooks'
import useIsReadOnly from '../../hooks/useIsReadOnly'
import { icons } from '../../styles/images'
import { notifyReadOnlyRejection } from '../../utils/readOnly'
import { Icon } from '../atoms/Icon'
import GTButton from '../atoms/buttons/GTButton'
import { CollapsedIconContainer, CollapsedNavButton } from '../navigation_sidebar/NavigationLink'
import Tip from '../radix/Tip'
import NoteCreateModal from './NoteCreateModal'

interface NoteCreateButtonProps {
    type: 'icon' | 'button' | 'collapsed'
    disableShortcut?: boolean
}
const NoteCreateButton = ({ type, disableShortcut }: NoteCreateButtonProps) => {
    const [modalIsOpen, setModalIsOpen] = useState(false)
    const isReadOnly = useIsReadOnly()
    const openModal = useCallback(() => (isReadOnly ? notifyReadOnlyRejection() : setModalIsOpen(true)), [isReadOnly])

    useKeyboardShortcut('newNote', openModal, disableShortcut)

    return (
        <>
            {type === 'icon' && (
                <GTButton styleType="icon" icon={icons.penToSquare} onClick={openModal} shortcutName="newNote" />
            )}
            {type === 'button' && (
                <GTButton styleType="control" value="Create new note" icon={icons.penToSquare} onClick={openModal} />
            )}
            {type === 'collapsed' && (
                <Tip shortcutName="newNote" side="right">
                    <CollapsedNavButton type="button" aria-label={KEYBOARD_SHORTCUTS.newNote.label} onClick={openModal}>
                        <CollapsedIconContainer>
                            <Icon icon={icons.penToSquare} />
                        </CollapsedIconContainer>
                    </CollapsedNavButton>
                </Tip>
            )}
            <NoteCreateModal isOpen={modalIsOpen} setIsOpen={setModalIsOpen} />
        </>
    )
}

export default NoteCreateButton
